export default __webpack_public_path__ + "static/media/down-arrow.0eb8ab81.svg";